module.exports = __webpack_public_path__ + "img/s03_p01.e2e043f0.jpg";